/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";
import Rest = require("../../Generated/RestClient");
import {
    AzurePortalPage, AzurePortalPageProps, AzurePortalPageState,
    BotAppSettings, BotAppSettingsProps
} from "../Views/index";
import {BotControllerBase} from "./BotControllerBase";
import { DevPortalAppBase } from "../../DevPortalAppBase";
import {BotController} from "./BotController";
import isInFrame from "../../../../Intercom.ReactUI/Utils/InFrame";
import {downloadBotSource} from "../Services/downloadBotSrc";
import logger from "../../../../Intercom.ReactUI/Utils/logger";
import { Environment } from "../../../../Intercom.ReactUI/Utils/Environment";
import {KuduClient} from "../../Services/KuduApi";
import {Poller, PollingModel} from "../../Models/PollingModel";
import {clientAppSettings} from "../../Models/ClientAppSettings";
import {ArmClient, WebAppService} from "../../Services/ArmApi";
import {BladeType} from "../Services/azurePortalLinks";
import {lazy} from "../../Decorators/index";
import {BotProgress} from "../Views/status/BotProgress";

import { AuthenticationUtility } from "../Utility/AuthenticationUtility";

export class Verbs {
    // Initialization verbs
    public static message = "message";
    public static ready = "ready";

    // Requests from iframe
    public static getStartupInfo = "get-startup-info";
    public static openBlade = "open-blade";
    public static openBladeWithInputs = "open-blade-inputs";
    public static logAction = "log-action";
    public static logMessage = "log-message";
    public static setDirtyState = "set-dirtystate";

    // Requests from Ibiza
    public static sendStartupInfo = "send-startup-info";
    public static sendResourceId = "send-resourceId";
    public static sendInputs = "send-inputs";
    public static sendAppSettingName = "send-appSettingName";
    public static sendToken = "send-token";
    public static sendToken2 = "send-token2";
}

export interface IbizaMessage {
    signature: string;
    kind: string;
    data: any;
}

export interface IbizaEvent {
    data: IbizaMessage;
}

export interface StartupInfo {
    sessionId: string,
    token: string,
    selfToken?: string,
    effectiveLocale: string,
    ignoreSendToken?: boolean
}

export interface IbizaBlade {
    detailBlade: string,
    detailBladeInputs: any,
    extension: string
}

const BladeNames = {
    continuousIntegration: 'ContinuousDeploymentListBlade',
    webConfig: 'SiteConfigSettingsFrameBlade',
    appSettings: 'AppsOverviewBlade',
    functionEditor: 'FunctionsIFrameBlade'
}

/**
 * for creating cross frame message between azure portal and our bot page"
 */
const portalSignature = "FxAppBlade";

export class AzurePortalPageController extends BotControllerBase {
    private component: AzurePortalPage;
    private state: AzurePortalPageState;
    private shellSrc: string;
    private rsrcId: string;
    private startupInfo: StartupInfo;
    private messageHandler: EventListener;
    private _scmPoller: Poller<string>;
    private _deployPoller: Poller<boolean>;
    private deploymentLog: Rest.VfsNodeInfo;
    private _botAppSettings: BotAppSettings;

    protected setBotAppSettings(x: any) {
        this._botAppSettings = x;
        if (this._botAppSettings) {
            logger.debug('hooking up botAppSettings');
            this._botAppSettings.setState(this.state);
        }
    }

    private get botAppSettings(): BotAppSettings {
        return this._botAppSettings;
    }

    constructor(app: DevPortalAppBase) {
        super(app);

        Environment.isInAzurePortal = true;

        $('body').toggleClass("inframe", isInFrame());
        window.refreshBot = () => {
            this.fetchBot();
        };
    }

    protected pageRequiresSignIn(): boolean {
        //  require sign in if we are not hosted in azure portal, or we got the token from azure portal already
        return !isInFrame() || !!(this.startupInfo && this.startupInfo.token);
    }

    // override controller base updateState for inframe sign in, we need to get the botId to complete loading the page
    protected updateState(signInInProgress: boolean, signInError: string, callback?: () => void): void{
        logger.debug('updateState is called on tabpagecontroller');
        var wrapped = callback ? _.wrap(callback, fn => {
            fn();
            logger.debug('signInInProgress = ', signInInProgress, 'signInError = ', signInError);
            if (isInFrame()) {
                if (this.app.signedInUser && this.startupInfo && this.startupInfo.token) {
                    logger.debug('set signedInUser.AzureToken = this.startupInfo.token in updateState');
                    this.app.signedInUser.AzureToken = this.startupInfo.token;
                }
                if (this.app.signedInUser && !this.botId) {
                    this.loadAzureResource();
                } else if (!this.app.signedInUser) {
                    logger.debug('missing this.app.signedInUser');
                }
            }
        }) : undefined;
        super.updateState(signInInProgress, signInError, wrapped as any);
    }

    get scmPoller(): Poller<string> {
        if (!this._scmPoller) {
            this._scmPoller = new Poller({ defaultInterval: 10000, maxPendingPollRequests: 1 },
                () => this.pollScmType(),
                scmType => {
                    if (scmType != this.state.scmType) {
                        this.scmPoller.stop();
                        console.log(`set state.scmType = ${scmType}`);
                        this.state.scmType = scmType;
                        this.syncState();
                        if (this.botAppSettings) {
                            this.botAppSettings.setState(this.state);
                        }
                        if (this.botController) {
                            this.botController.refreshScmType();
                        }
                    }
                });
        }
        return this._scmPoller;
    }

    public refreshScmType() {
        this.pollScmType().then(scmType => this.state.scmType = scmType);
    }

    private pingDeployLog(): JQueryPromise<boolean> {
        let result = $.Deferred<boolean>();
        this.kuduClient
            .then(kc => {
                kc.get(`${kc.scmUri.format()}/api/vfs/site/`).then(
                    (nodes: any) => {
                        let node = _.find(nodes, (x: Rest.VfsNodeInfo) => x.name.toLowerCase() == "deployment.log");
                        result.resolve(!!node);
                    }
                ).fail(
                    () => { result.resolve(false) });
            });

        return result;
    }

    get deployPoller(): Poller<boolean> {
        if (!this._deployPoller) {
            let pollSetting: PollingModel = this.deploymentLog ? {
                defaultInterval: 60000, // 1 minute
                maxPendingPollRequests: 1
            } : {
                    defaultInterval: 10000, // 10 seconds
                    maxPendingPollRequests: 1
                };

            this._deployPoller = new Poller(pollSetting,
                () => this.pingDeployLog(),
                found => {
                    const prevFound = this.state.botDeploymentLogFound;
                    this.state.botDeploymentLogFound = found;
                    if (!prevFound && found) {
                        this.syncState();
                        if (this.botAppSettings) {
                            this.botAppSettings.setState(this.state);
                        }
                        this.deployPoller.stop();
                        if (this.state.scmType !== 'none') {
                            // we have continuous integration on, poll to check if
                            // there is a new deployment pushed
                            this._deployPoller = null;
                            this.deployPoller.start();
                        }
                    }
                });
        }
        return this._deployPoller;
    }

    private setupCrossFrameMessaging() : void {
        if (isInFrame() && !this.messageHandler) {
            try {
                logger.debug('bind message handler');
                logger.debug('continue logging');
                this.messageHandler = _.bind(this.onReceiveMessage, this);
            } catch (ex) {
                logger.debug(`bound messageHandler error ${ex}`);
            }
            logger.debug('bound messageHandler');
            logger.debug('add inframe listener');
            window.addEventListener(Verbs.message, this.messageHandler, false);
            logger.debug('done window.addEventListener');
            // This is a required message. It tells the shell that your iframe is ready to receive messages.
            this.postMessage(Verbs.ready, null);
            this.postMessage(Verbs.getStartupInfo, null);
        } else {
            if (!isInFrame()) {
                logger.debug('we are not in an iframe');
            } else if (this.messageHandler) {
                logger.debug('cross frame message handler already setup');
            }
        }
    }

    public render(params: SimpleMvc.QueryParams): void {
        super.render(params);

        this.shellSrc = this.shellSrc || params["shellSrc"];
        this.rsrcId = this.rsrcId || params["rsrcId"];

        this.botId = params["id"];
        this.state = {
            botId: this.botId,
            scmType: 'none'
        }

        if (this.app.signedInUser && this.botId) {
            this.fetchBot();
        }

        this.setupCrossFrameMessaging();

        logger.debug('AzurePortalPageController loaded');
    }

    public unload() {
        logger.debug('AzurePortalPageController unloaded');
        if (this.messageHandler) {
            window.removeEventListener(Verbs.message, this.messageHandler, false);
            this.messageHandler = null;
        }
        super.unload();
    }

    private pollScmType(): JQueryPromise<string> {
        return this.kuduClient.then(client => {
            return client.settings;
        }).then(settings => {
            return $.Deferred<string>().resolve(settings['ScmType']);
        });
    }

    public get botAppSettingsProps(): BotAppSettingsProps {
        if (!isInFrame()) {
            return null;
        }
        return {
            openBlade: _.bind(this.openBlade, this),
            handleChange: null,
            onDropIcon: null,
            onSave: null,
            downloadZip: _.bind(this.downloadZip, this),
            onZipDownloaded: blobUrl => {  },
            scmType: this.pollScmType(),
            initialBot: this.botSub ? this.botSub.Bot : null,
            v4UI: true,
            kuduClient: this.kuduClient,
            armClient: $.Deferred<ArmClient>().resolve(this.armClient)
        };
    }

    public openBlade(bladeType: BladeType) {
        const bladeName = BladeNames[BladeType[bladeType]];
        let bladeInputs: any;
        console.log(`bladeName=${bladeName}`);

        switch (bladeType) {
            case BladeType.appSettings:
                bladeInputs = { id: this.rsrcId };
                break;
            case BladeType.webConfig:
                bladeInputs = { id: this.rsrcId };
                break;
            case BladeType.continuousIntegration:
                bladeInputs = { ResourceId: this.rsrcId, id: this.rsrcId };
                break;
            case BladeType.functionEditor:
                bladeInputs = { id: this.rsrcId, resourceId: this.rsrcId };
                break;
        }

        // we don't have a way to register blade close event handler
        // so we just use polling here to watch if user has changed scmType
        if (bladeType == BladeType.continuousIntegration) {
            // start polling scmType change
            if (this.scmPoller.isStopped()) {
                this.scmPoller.start();
            }
        } else {
            // heuristically stop polling when user opens another blade
            this.scmPoller.stop();
        }

        const blade: IbizaBlade = {
            detailBlade: bladeName,
            detailBladeInputs: bladeInputs,
            extension: 'WebsitesExtension'
        };
        this.postMessage(Verbs.openBlade, blade);
    }

    private updateBot(bot: Rest.BotService, reviewStatus: Rest.ReviewStatusDetail) {
        this.state = _.extend(this.state, {
            bot: bot
        });

        this.botSub.Bot = bot;
        this.botSub.ReviewStatusDetail = reviewStatus;
        this.syncState();
        if (this.botAppSettings) {
            this.botAppSettings.setState(this.state);
        }
    }

    @lazy()
    private get kuduClient(): JQueryPromise<KuduClient> {
        return Rest.CodeClient.getScmAuthz(this.botId).then(x => {
            return $.Deferred<KuduClient>().resolve(KuduClient.createFromScmAuthorization(x));
        }).fail(xhr => {
            this.handleHttpResponseError(xhr);
        });
    }

    private downloadZip(): JQueryPromise<Blob> {
        return downloadBotSource(this.kuduClient);
    }

    protected saveBotStateAndRender(botSub: Rest.BotSubscription) {
        if (botSub.Bot) {
            logger.debug('saveBotStateAndRender', botSub.Bot.Id);
            (this.botController as any).saveBotStateAndRender(botSub);
        }
    }

    @lazy()
    private get botController(): BotController {
        return new BotController(this.app, this, this.botAppSettingsProps);
    }

    private get AzureBotServiceVersion(): string {
        return window.location.pathname.indexOf('codev2') >= 0 ? "ABSv2" : "ABSv1";
    }

    private get hosting() : JQueryPromise<string> {
        return this.webApp.then(app => {
            return $.Deferred<string>().resolve(app.kind.split(',').indexOf('app') >= 0 ? 'webapp' : undefined);
        }, () => {
            return $.Deferred<string>().resolve(undefined);
        });
    }

    private get serverFarmId() : JQueryPromise<string> {
        return this.webApp.then(app => {
            return $.Deferred<string>().resolve(app.properties.serverFarmId);
        }, () => {
            return $.Deferred<string>().resolve(undefined);
        });        
    }

    private get location(): JQueryPromise<string> {
        return this.webApp.then(app => {
            return $.Deferred<string>().resolve(app.location);
        }, () => {
            return $.Deferred<string>().resolve(undefined);
        });                
    }

    private renderPage() : JQueryPromise<AzurePortalPage> {
        
        let element = React.createElement(AzurePortalPage, {
            botPageProps: this.botSub ? this.botController.getBotPageProps(this.botSub) : null,
            onSetComponent: x => {
                this.component = x;
                if (x)  {
                    x.setState(this.state);
                }
            }
        });
        ReactDOM.render<AzurePortalPageProps, AzurePortalPage>(element, this.pageContent);
        return $.Deferred<AzurePortalPage>().resolve(this.component);        
    }

    private getShellSrc() {
        if (!this.shellSrc && isInFrame()) {
            this.shellSrc = window.location.search.match(/=(.+)/)[1];
        }
        return this.shellSrc;
    }

    private postMessage(verb: string, data: string | IbizaBlade) {
        if (isInFrame()) {
            logger.debug(`post message ${verb}`);
            window.parent.postMessage(<IbizaMessage>{
                signature: portalSignature,
                kind: verb,
                data: _.isString(data) ? data : JSON.stringify(data)
            }, this.getShellSrc());
        }
    }

    private setBotId(botId: string) {
        if (this.botId !== botId) {
            this.botId = botId;
            this.state.botId = botId;
            this.statusBar = React.createElement(BotProgress, {progress: 'Loading bot'});
            this.renderPage().then(comp => {
                comp.setState(this.state, () => {
                    if (botId) {
                        this.fetchBot().then(() => {
                            this.statusBar = null;
                        });
                    } else {
                        this.statusBar = null;
                    }
                });
            });
        }
    }

    private syncState() {
        if (this.component) {
            this.component.setState(this.state);
        }
    }

    private fetchBot(): JQueryPromise<Rest.BotSubscription> {
        logger.debug('AzurePortalPageController fetchBot');

        Rest.BotManagerClient.getConfigSettings(this.botId).then(config => {
            this.state.scmType = config.properties.scmType;
            this.syncState();
        });

        return Rest.BotManagerClient.getById(this.botId)
        .then(botSub => {
            this.botSub = botSub;
            return this.botController.loadBotState(botSub.Bot);
        })
        .then(()=> {
            return $.Deferred<Rest.BotSubscription>().resolve(this.botSub);
        })
        .done(botSub => {
            this.saveBotStateAndRender(botSub);
            this.pingDeployLog().then(found => {
                if (found) {
                    this.state.botDeploymentLogFound = true;
                    this.syncState();
                }
                if (!found || this.state.scmType !== 'none') {
                    this.deployPoller.start();
                }
            });
        })
        .fail(xhr => {
            if (xhr.status == 404 && isInFrame()) {
                // this is the create flow
                logger.debug(`can't locate bot for  ${this.botId}`);
                this.botId = null;
                this.state.botId = null;
                this.syncState();
            } else {
                this.handleHttpResponseError(xhr)
            }
        });
    }

    private bindAzureAccessToken() {
        const token = this.startupInfo.token;
        if (token) {
            const authData = this.app.signedInUser;
            if (authData) {
                authData.AzureToken = token;
            } else {
                logger.debug('this.app.signedInUser not set');
            }
            // when hosted in Azure portal, the tenant Id of the user
            // is the one we want to use by definition
            const headers =  { 
                'X-BF-OAUTH-TOKEN': token, 
                'X-BF-TenantId' : this.app.signedInUser.TenantId 
            };
            Rest.ajaxHeaders = _.extend(Rest.ajaxHeaders || {}, headers);
        } else {
            logger.debug('this.starupInfo.token not set');
        }
    }

    private handleRefreshAuthFailure() {
        if (!this.component) {
            this.renderPage().then(comp => {
                comp.setState(this.state);
            });
        } else {
            this.syncState();
        }
    }

    private refreshAuthToken(useSelfToken: boolean = true) {
        if (isInFrame()) {
            const csrfToken = AuthenticationUtility.getCsrfToken()
            if (!csrfToken) {
                logger.debug("AzurePortalPageController: Failed to get CSRF token from cookie.");
                this.handleRefreshAuthFailure();
                return;
            }

            $.ajax('/refreshLogin', {
                data: {
                    token: useSelfToken ? this.startupInfo.selfToken || this.startupInfo.token : this.startupInfo.token,
                    '__RequestVerificationToken': csrfToken
                },
                type: 'POST'
            })
            .then(() => Rest.AccountClient.getSignedInUser())
            .then(() => {
                // refresh successful
                if (!this.app.signedInUser) {
                    logger.debug('reload BotTabPageController');
                    this.refreshSignedInUser();
                    this.bindAzureAccessToken();
                    // reload the controller which will get the signed in user
                    if (this.component) {
                        this.component.forceUpdate();
                    }
                } else {
                    logger.debug('user already signed in');
                    this.bindAzureAccessToken();
                    if (!this.botId) {
                        logger.debug('load azure reosurce');
                        this.loadAzureResource();
                    }
                }
            })
            .fail(xhr => {
                this.handleHttpResponseError(xhr);
            });
        }
    }

    @lazy()
    private get armClient() : ArmClient {
        return new ArmClient(this.startupInfo.token);
    }

    @lazy()
    private get webApp() : JQueryPromise<WebAppService> {
        if (this.rsrcId && this.startupInfo && this.startupInfo.token) {
            return this.armClient.getWebAppService(this.rsrcId);
        }
        return $.Deferred<WebAppService>().reject('no startupInfo or rsrcId');
    }

    private loadAzureResource() {
        if (this.app.signedInUser && this.startupInfo.token && this.rsrcId) {
            logger.debug('AzurePortalPageController loadAzureResource');
            Rest.CodeClient.fetchBotId(this.rsrcId, this.startupInfo.token).done(botId => {
                this.setBotId(botId)
            }).fail(xhr => {
                if (xhr.status == 404 && isInFrame()) {
                    // this is the create flow
                    logger.debug(`can't locate bot for rsrcId ${this.rsrcId}`);
                    this.webApp.always(() => {
                        this.setBotId(null);
                    })
                } else {
                    this.handleHttpResponseError(xhr)
                }
            });
        }
    }

    private get isFirstPartyAuth() : boolean {
        return clientAppSettings.flightedFeatures.indexOf('firstPartyAuth') >= 0;
    }

    private onReceiveMessage(event: IbizaEvent) {
        if (!event || !event.data || event.data.signature !== portalSignature) {
            return;
        }

        let data = event.data.data;
        let methodName = event.data.kind;

        logger.debug("[iFrame] Received mesg: " + methodName);

        switch (methodName) {
            case Verbs.sendResourceId:
                this.rsrcId = data;
                break;
            case Verbs.sendInputs:
                this.rsrcId = data['resourceId'];
                break;
            case Verbs.sendStartupInfo:
                {
                    const si = <StartupInfo>data;
                    let refreshToken = true;
                    if (this.botId && si && si.token && this.startupInfo && si.token === this.startupInfo.token) {
                        refreshToken = false;
                    }

                    this.startupInfo = si;
                    this.statusBar = React.createElement(BotProgress, {progress: 'Initializing'});
                    if (this.startupInfo.token && refreshToken) {
                        this.refreshAuthToken(this.isFirstPartyAuth);
                    }
                }
                break;
            case Verbs.sendAppSettingName:
                // TODO: manage app setting namges
                break;
            case Verbs.sendToken:
                {
                    if (this.startupInfo && !this.startupInfo.ignoreSendToken) {
                        this.startupInfo.token = data;
                        this.refreshAuthToken(false);
                    }                    
                }
                break;
            case Verbs.sendToken2:
                {
                    if (this.startupInfo && this.isFirstPartyAuth) {
                        this.startupInfo.ignoreSendToken = true;
                        this.startupInfo.selfToken = data.selfToken;
                        this.startupInfo.token = data.token;
                        this.refreshAuthToken();
                    }
                }
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Controllers/AzurePortalPageController.ts